
import {
  reactive,
  ref,
  h,
  defineComponent,
  createSlots,
  renderSlot,
  RendererOptions,
} from "vue";
// Import component
import { useLoading } from "vue3-loading-overlay/dist/index";
import "vue3-loading-overlay/dist/vue3-loading-overlay.css"

const CustomSlot = defineComponent({
  template: `<div class="custom-slot" :style="{color:color}"><h3>Wait ...</h3></div>`,
});

export default {
  setup() {
    const formContainer = ref<any>(null);

    const viewmodel = reactive({
      fullPage: true,
      canCancel: true,
      useSlot: false,
      loader: "dots",
      timeout: 3000, //ms
      color: "#00ab00",
      bgColor: "#4b4b4b",
      height: 64,
      width: 64,
    });
    const whenCancelled = () => {
      console.log("User cancelled the loader.");
    };

    const simulate = () => {
      const slots = viewmodel.useSlot
        ? {
            // https://vuejs.org/v2/guide/render-function.html#createElement-Arguments
            default: (props: any) => h(CustomSlot, props),
          }
        : {};

      const loader = useLoading();
      loader.show(
        {
          container: viewmodel.fullPage ? null : formContainer.value,
          canCancel: viewmodel.canCancel,
          onCancel: whenCancelled,
          color: viewmodel.color,
          backgroundColor: viewmodel.bgColor,
          height: viewmodel.height,
          width: viewmodel.width,
          loader: viewmodel.loader,
          opacity: 0.3,
        },
        slots
      );

      // simulate async call
      setTimeout(() => {
        loader.hide();
      }, viewmodel.timeout);
    };

    return {
      viewmodel,
      simulate,
      formContainer,
    };
  },
};
